import bird from "../assets/sketch/bird.jpg";
import babaMama from "../assets/sketch/baba&mama.jpg";
import didi from "../assets/sketch/didi.jpg"
import malay from "../assets/sketch/malay.jpg"
import manaswita from "../assets/sketch/manaswita.jpg"
import papan from "../assets/sketch/papanbhai.jpg"
import guduLadu from "../assets/sketch/gudu ladu.jpg"
import debarsee from "../assets/sketch/debarsee.jpg"
import payal from "../assets/sketch/payal.jpg"
import priti from "../assets/sketch/priti.jpg"
import space from "../assets/sketch/space.jpg"
import debasish from "../assets/sketch/debasish sir.jpg"


export const sketchData = [
    {
        title: "Flory",
        details: "I made a portrait sketch of my sister on her birthday.",
        img: didi
    },
    {
        title: "Payal",
        details: "Birthday portrait sketch of my friend.",
        img: payal
    },
    {
        title: "Debarsee",
        details: "Birthday portrait sketch of my friend.",
        img: debarsee
    },
    {
        title: "Maxwell Jenkins",
        details: "A sketch of character from Lost in Space.",
        img: space
    },
    {
        title: "Manaswita",
        details: "Birthday portrait sketch of my friend.",
        img: manaswita
    },
    {
        title: "Malay",
        details: "Birthday portrait sketch of my friend.",
        img: malay
    },
    {
        title: "Papan & Miki",
        details: "Sketch of my cousin brother on his marriage.",
        img: papan
    },
    {
        title: "Baba & Mama",
        details: "A gift for my Baba and Mama on there anniversary.",
        img: babaMama
    },
    {
        title: "Debasish Sir",
        details: "Sketch of my teacher on teacher's day.",
        img: debasish
    },
    {
        title: "Free Bird",
        details: "Just a random sketch.",
        img: bird
    },
    {
        title: "Gudu & Ladu",
        details: "Birthday sketch of twins Gudu and Ladu.",
        img: guduLadu
    },
    {
        title: "Priti",
        details: "Birthday portrait sketch of my friend.",
        img: priti
    }

]